import React from "react";
import { SpinnerWrap } from "./styles";

const Spinner = ({ height, width, color, marginTop, marginLeft, marginRight }) => {
  return <SpinnerWrap height={height} width={width} color={color} marginTop={marginTop} marginRight={marginRight} marginLeft={marginLeft}></SpinnerWrap>;
};

export { Spinner };
